module.exports = __webpack_public_path__ + "assets/static/png/ico-sms-control.f23130b3996924895592cdb8bff1d7f3.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/main/images/ico-sms-control.png
 ** module id = 493
 ** module chunks = 1
 **/